import { createToaster } from '@chakra-ui/react';

export const toaster = createToaster({
  placement: 'top-end',
  pauseOnPageIdle: true,
  duration: 5000,
  // Show one toast at a time — extras are queued and surfaced as each dismisses.
  max: 1,
  overlap: false,
});
